import {listPageStyles} from "../../../../../../../../../../../Modelportfolios/List/styles";

const styles = theme => ({
  ...listPageStyles,
  tableCell: {
    width: 100,
    '&:nth-child(2)': {
      minWidth: 83,
      whiteSpace: 'normal'
    },
    '&:first-child': {
      width: 350,
      maxWidth: 350,
    },
    whiteSpace: 'nowrap'
  },
  containerName: {
    marginLeft: '9px !important'
  },
  containerCheckbox: {
    marginLeft: 5
  },
});

export default styles;